// src/components/kuestion/solo/SoloBilling.jsx
// Shape only. A solo account pays for itself and nobody else.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stat } from '../shared/Bits';
import { kq } from '../../../config/routes';

export default function SoloBilling() {
  const navigate = useNavigate();
  return (
    <div className="kqc-page kqc-page--narrow" style={{ maxWidth: 820 }}>
      <div className="kqc-row" style={{ marginBottom: 10 }}>
        <span className="kqc-kicker">Billing</span>
        <span className="tag tag-outline">Not built yet — shape only</span>
      </div>
      <h1 className="kqc-h1" style={{ marginBottom: 12 }}>Your plan</h1>
      <p className="kqc-lede" style={{ marginBottom: 26 }}>A solo account pays for itself and nobody else. Seats, student logins and cohort reporting belong to Campus accounts.</p>
      <div className="kqc-stats" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))' }}>
        <Stat label="Plan" value="—" size="md" />
        <Stat label="Token balance" value="—" />
        <Stat label="Renews" value="—" size="md" />
      </div>
      <div className="kqc-box kqc-box--soft" style={{ maxWidth: 560 }}>
        <div className="kqc-box__body">
          <div className="kqc-mono" style={{ fontSize: 15, marginBottom: 6 }}>Teaching a class later?</div>
          <div className="kqc-small" style={{ color: 'var(--color-neutral-800)', marginBottom: 14 }}>This account is Solo, and that is permanent &mdash; it cannot be converted into an examiner account. Running a class means signing up again with a different email, which gives you an organisation, student logins and cohort reporting from the start.</div>
          <button type="button" className="btn btn-secondary btn-sm" style={{ minHeight: 40 }} onClick={() => navigate(kq('account'))}>Why can&rsquo;t I switch?</button>
        </div>
      </div>
    </div>
  );
}
